import en from './catalogs/en.json' with { type: 'json' };
import es from './catalogs/es.json' with { type: 'json' };
import pt from './catalogs/pt.json' with { type: 'json' };
import fr from './catalogs/fr.json' with { type: 'json' };
import de from './catalogs/de.json' with { type: 'json' };
import it from './catalogs/it.json' with { type: 'json' };
import nl from './catalogs/nl.json' with { type: 'json' };
import pl from './catalogs/pl.json' with { type: 'json' };
import type { Catalogs } from './translate.js';

export * from './languages.js';
export * from './translate.js';
export * from './format.js';

/** Bundled interface catalogs. Languages without a catalog fall back to English. */
export const CATALOGS: Catalogs = { en, es, pt, fr, de, it, nl, pl };
